export default "__VITE_ASSET__aJGr6Ypr__"